import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { MOCK_TRUSTED } from "@/src/common/components/product-demo/mock-data";

const MARQUEE_STYLE: CSSProperties & { "--marquee-duration": string } = { "--marquee-duration": "42s" };

export function TrustedByBar() {
	const { t } = useTranslation("home");
	const items = [...MOCK_TRUSTED, ...MOCK_TRUSTED];

	return (
		<section className="relative overflow-hidden border-y border-default-200/60 bg-content1/40 py-10">
			<div className="mx-auto mb-6 max-w-7xl px-4 text-center sm:px-6 lg:px-8">
				<p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-default-500">{t("trusted_by.eyebrow")}</p>
			</div>

			<div className="marquee-mask marquee-pause overflow-hidden">
				<div className="marquee-track flex w-max items-center gap-10" style={MARQUEE_STYLE}>
					{items.map((item, idx) => (
						<div
							key={`${item.name}-${idx}`}
							className="marquee-logo flex shrink-0 items-center gap-3 rounded-2xl border border-default-200/60 bg-white px-4 py-3 shadow-sm hover:shadow-card"
							aria-hidden={idx >= MOCK_TRUSTED.length ? "true" : undefined}
						>
							<span
								aria-hidden="true"
								className="flex size-9 items-center justify-center rounded-full bg-brand-gradient text-xs font-bold text-white"
							>
								{item.initials}
							</span>
							<span className="text-sm font-semibold text-default-700">{item.name}</span>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
